import { Surfaces } from "@netlify/sdk--ui-core";
import { cn } from "@netlify/ui";
import React from "react";
import { useNetlifySDK } from "../../use_netlify_sdk.js";

/**
 * @internal
 */
export type SiteBuildGameSurfaceProps = {
  className?: string | undefined;
  children?: React.ReactNode | undefined;
};

/**
 * A container element used to render the SiteBuildGame surface. This component
 * will take care of styling your component so it looks good rendered
 * in the build game modal on your site build in the Netlify UI.
 *
 * @param props
 * @see Surfaces.SiteBuildGame
 * @example
 * ```tsx
 * import { SiteBuildGameSurface } from "@netlify/sdk/react/components";
 *
 * <SiteBuildGameSurface>
 *   <div>Your surface content goes here</div>
 * </SiteBuildGameSurface>
 * ```
 * @internal
 */
export const SiteBuildGameSurface = ({
  className,
  children,
  ...otherProps
}: SiteBuildGameSurfaceProps) => {
  const sdk = useNetlifySDK();

  return (
    <section
      id={`section-${Surfaces.SiteBuildGame}-${sdk.extension.slug}`}
      /**
       * Added dark:tw-bg-black to this element so that it fits in to the
       * game modal in netlify-react-ui with the correct background color.
       */
      className={cn("dark:tw-bg-black", className)}
      {...otherProps}
    >
      {children}
    </section>
  );
};
